<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 28">
        <g
            id="Layer_2"
            data-name="Layer 2">
            <g
                id="Layer_1-2"
                data-name="Layer 1">
                <g
                    id="Group_18515-3"
                    data-name="Group 18515-3">
                    <g
                        id="Group_18516-3"
                        data-name="Group 18516-3">
                        <rect
                            id="Rectangle_27249-9"
                            data-name="Rectangle 27249-9"
                            class="border-rect"
                            x="1.82"
                            y="2"
                            width="24"
                            height="24"
                            rx="4" />
                        <line
                            id="Line_37-9"
                            data-name="Line 37-9"
                            class="h-separator"
                            x1="1.82"
                            y1="8.34"
                            x2="25.44"
                            y2="8.34" />
                        <path
                            id="Path_5145-9"
                            data-name="Path 5145-9"
                            class="status-light"
                            d="M7.24,5A.86.86,0,0,1,5.53,5,.86.86,0,1,1,7.24,5Z" />
                        <path
                            id="Path_5146-9"
                            data-name="Path 5146-9"
                            class="status-light"
                            d="M11.12,5a.85.85,0,0,1-1.7,0,.85.85,0,1,1,1.7,0Z" />
                        <path
                            id="Path_5147-9"
                            data-name="Path 5147-9"
                            class="status-light"
                            d="M15,5a.85.85,0,1,1-1.7,0A.85.85,0,1,1,15,5Z" />
                        <path
                            id="Path_5148-3"
                            data-name="Path 5148-3"
                            class="brush-bristles"
                            d="M12.18,19.3a2.11,2.11,0,0,1,3,3c-.82.83-4.68,1.69-4.68,1.69C11.61,22.22,11.35,20.13,12.18,19.3Z" />
                        <path
                            id="Path_5149-3"
                            data-name="Path 5149-3"
                            class="brush-handle"
                            d="M20.1,12.79c2.13-2.14,2.56-1.73,3.07-1.22s.91.94-1.22,3.07a35.77,35.77,0,0,1-4.74,3.94,2.07,2.07,0,0,0-1.05-1A35,35,0,0,1,20.1,12.79Z" />
                        <line
                            id="Line_38-3"
                            data-name="Line 38-3"
                            class="h-separator"
                            x1="4.03"
                            y1="11.78"
                            x2="13.31"
                            y2="11.78" />
                        <line
                            id="Line_39-3"
                            data-name="Line 39-3"
                            class="h-separator"
                            x1="4.03"
                            y1="14.22"
                            x2="11.61"
                            y2="14.22" />
                        <line
                            id="Line_40-3"
                            data-name="Line 40-3"
                            class="h-separator"
                            x1="4.03"
                            y1="16.66"
                            x2="9.9"
                            y2="16.66" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<style>
    .h-separator {
        fill: none;
    }
    .border-rect,
    .status-light {
        fill: #ffffff;
    }
    .border-rect,
    .status-light,
    .h-separator,
    .brush-bristles,
    .brush-handle {
        stroke: var(--bs-primary-700);
        stroke-linecap: round;
        stroke-linejoin: round;
    }
    .brush-bristles {
        fill: var(--bs-primary-200);
    }
    .brush-handle {
        fill: var(--bs-primary-500);
    }
</style>
